export default "__VITE_ASSET__DVk34_vI__"